var _g, _g2, _path, _path2, _path3, _path4, _g3, _path5, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWavingHandSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "waving-hand-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.348,
    height: 47.693,
    viewBox: "0 0 49.348 47.693",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_552",
    "data-name": "Group 552",
    transform: "translate(0 0.089)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M14.176,45.288a6.059,6.059,0,0,1-1.152-.329c-.411-.165-.74-.247-1.069-.411A10.488,10.488,0,0,1,9.9,43.314a10.516,10.516,0,0,1-3.208-3.619,10.356,10.356,0,0,1-1.4-4.606A11.581,11.581,0,0,1,5.375,32.7c.082-.411.165-.74.247-1.152s.247-.74.329-1.152l.082,1.152A5.554,5.554,0,0,0,6.2,32.7a16.426,16.426,0,0,0,.411,2.139A13.652,13.652,0,0,0,8.172,38.79,17.463,17.463,0,0,0,10.8,42.245c.494.494,1.069.987,1.645,1.481a8.742,8.742,0,0,0,.9.74l.823.823",
    transform: "translate(-2.578 -7.944)",
    fill: "#42ade2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M13.351,50.734a2.947,2.947,0,0,1-.9.329,3.5,3.5,0,0,1-.9.165,7.143,7.143,0,0,1-1.892.082,9.128,9.128,0,0,1-3.619-.987,6.978,6.978,0,0,1-2.8-2.55,10.537,10.537,0,0,1-.9-1.645c-.082-.247-.165-.576-.247-.9,0-.247-.082-.494-.082-.823.247.247.411.494.576.658.247.247.411.494.576.658A15.2,15.2,0,0,0,4.3,46.868,11.873,11.873,0,0,0,6.935,48.76,18.729,18.729,0,0,0,9.9,49.993c.494.165,1.069.247,1.645.411.247.082.576.082.823.165.411.082.658.082.987.165",
    transform: "translate(-2 -10.428)",
    fill: "#42ade2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M38.4,3.5a6.447,6.447,0,0,1,1.152.411c.411.165.74.329,1.069.494a17.508,17.508,0,0,1,2.056,1.316,10.919,10.919,0,0,1,4.277,8.472,11.745,11.745,0,0,1-.247,2.385,6.059,6.059,0,0,1-.329,1.152c-.165.411-.247.74-.411,1.069l-.082-1.152A5.431,5.431,0,0,0,45.8,16.5l-.247-2.221a15.431,15.431,0,0,0-3.866-7.65c-.494-.576-1.069-1.069-1.563-1.645a8.742,8.742,0,0,0-.9-.74L38.4,3.5",
    transform: "translate(-8.459 -3.171)",
    fill: "#42ade2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M47.1,3.1a2.463,2.463,0,0,1,.823.329,3.842,3.842,0,0,1,.823.411A16.68,16.68,0,0,1,50.226,4.91a7.417,7.417,0,0,1,2.056,2.961,6.831,6.831,0,0,1,.494,3.619,13.148,13.148,0,0,1-.411,1.727c-.082.247-.247.576-.329.823a3.863,3.863,0,0,1-.494.74V13.135c0-.576-.082-1.069-.082-1.563a11.165,11.165,0,0,0-.74-2.961A17.372,17.372,0,0,0,49.239,5.9c-.329-.411-.658-.9-.987-1.316a4.12,4.12,0,0,0-.576-.658A2.348,2.348,0,0,0,47.1,3.1",
    transform: "translate(-10.002 -3.1)",
    fill: "#42ade2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_553",
    "data-name": "Group 553",
    transform: "translate(4.782 0.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M9.612,17.927a3.249,3.249,0,0,0-1.481,4.36L18.5,43.92l5.758-2.714L13.889,19.49a3.123,3.123,0,0,0-4.277-1.563",
    transform: "translate(-7.813 -5.662)",
    fill: "#ffdd67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M40.472,32.546l6.087-2.879L34.714,4.99a3.385,3.385,0,0,0-6.087,2.961L40.472,32.546",
    transform: "translate(-11.447 -3.089)",
    fill: "#ffdd67"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M30.594,3.328a1.721,1.721,0,0,0-.494.329,3.435,3.435,0,0,1,3.948,1.81L45.893,30.143l1.069-.494L35.118,4.973a3.362,3.362,0,0,0-4.524-1.645",
    transform: "translate(-6.986 -2.991)",
    fill: "#eba352"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M25.119,39.672l6.334-3.043L19.361,11.458a3.5,3.5,0,1,0-6.334,2.961L25.119,39.672",
    transform: "translate(-3.897 -4.13)",
    fill: "#ffdd67"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M14.994,9.828a1.721,1.721,0,0,0-.494.329,3.6,3.6,0,0,1,4.113,1.892L26.1,27.76l1.81,1.069L19.682,11.555a3.488,3.488,0,0,0-4.689-1.727",
    transform: "translate(-4.218 -4.145)",
    fill: "#eba352"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M31.619,33.579l6.334-3.043L25.861,5.365A3.479,3.479,0,0,0,21.173,3.72a3.549,3.549,0,0,0-1.645,4.689l12.092,25.17",
    transform: "translate(-5.05 -3.055)",
    fill: "#ffdd67"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_554",
    "data-name": "Group 554",
    transform: "translate(6.087 0.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M21.494,3.628c-.165.082-.329.247-.494.329a3.6,3.6,0,0,1,4.113,1.892l8.472,17.767,1.81,1.069L26.182,5.355a3.512,3.512,0,0,0-4.689-1.727",
    transform: "translate(-11.458 -3.294)",
    fill: "#eba352"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M9.894,17.928a1.721,1.721,0,0,0-.494.329,3.132,3.132,0,0,1,3.7,1.81L19.271,32.98l1.81,1.069-6.91-14.477a3.1,3.1,0,0,0-4.277-1.645",
    transform: "translate(-9.4 -5.831)",
    fill: "#eba352"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M53.111,14.868c-2.221-1.727-5.84.165-7.65,6.087-1.234,4.113-1.4,5.347-4.031,6.58L39.95,24.492S16.59,35.761,17.494,37.571c0,0,2.8,8.719,7.568,12.75C32.136,56.407,48.67,49.909,49.41,34.2c.411-9.13,6.087-17.438,3.7-19.33",
    transform: "translate(-4.745 -4.99)",
    fill: "#ffdd67"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_555",
    "data-name": "Group 555",
    transform: "translate(22.538 9.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M55.228,14.876a2.986,2.986,0,0,0-1.4-.576c.082.082.247.082.329.165,2.468,1.892-.082,6.251-1.481,10.2C51.527,27.79,50.54,31,50.7,34.124c.658,13.655-13.079,20.153-21.3,17.685,8.061,3.373,23.032-3.043,22.374-17.274-.165-3.126.74-6.169,1.974-9.459,1.316-3.948,3.866-8.308,1.481-10.2",
    transform: "translate(-29.4 -14.3)",
    fill: "#eba352"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M45.533,30c-5.1.576-12.585,7.9-7.321,15.875-3.866-8.061,2.468-13.49,6.5-15.382A3.643,3.643,0,0,1,45.533,30",
    transform: "translate(-30.645 -17.086)",
    fill: "#eba352"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavingHandSvgrepoCom);
export default __webpack_public_path__ + "static/media/waving-hand-svgrepo-com.8d92957202e9ffd2d18e83647d7dd0a8.svg";
export { ForwardRef as ReactComponent };